"use strict";

var map_filters = {
    all_list: ".map-section .filters .selected-filters-list",
    filter_wrapper: ".map-section .filters .filter-groups",
    addOverflowToFilters: function addOverflowToFilters(tajmout) {
        setTimeout(function () {
            if ($(map_filters.filter_wrapper).height() > 820) $(".filter-info").css("overflow-y", "auto");
        }, tajmout ? 320 : 0);
    },
    close_div: function close_div(div) {
        $(div).slideUp("300");
    },
    open_div: function open_div(div) {
        $(div).slideDown("300");
    },
    filters_toggle: function filters_toggle() {

        $(".filters .title-wrap").each(function () {
            $(this).click(function () {
                if ($(this).parent().hasClass("open-filters")) map_filters.close_div($(this).parent().removeClass("open-filters").find(".filter-info"));else map_filters.open_div($(this).parent().addClass("open-filters").find(".filter-info"));
            });
        });
    },
    group_toggle: function group_toggle() {

        $(map_filters.filter_wrapper).find(".group-title").each(function () {
            $(this).click(function () {

                if ($(this).hasClass("opened")) map_filters.close_div($(this).removeClass("opened").next());else {

                    $(map_filters.filter_wrapper).find(".group-title.opened").each(function () {
                        //close all opened
                        map_filters.close_div($(this).removeClass("opened").next());
                    });
                    map_filters.open_div($(this).addClass("opened").next());
                }
                map_filters.addOverflowToFilters(true);
            });
        });
    },
    subgroup_toggle: function subgroup_toggle() {

        $(map_filters.filter_wrapper).find(".group-extended .sub-category:not(.single) .sub-category-title").each(function () {
            $(this).click(function () {

                if ($(this).parent().hasClass("checked-option")) map_filters.close_div($(this).parent().removeClass("checked-option").find(".category-extended"));else {
                    $(this).parent().siblings(".checked-option").each(function () {
                        //close all opened
                        map_filters.close_div($(this).removeClass("checked-option").find(".category-extended"));
                    });
                    map_filters.open_div($(this).parent().addClass("checked-option").find(".category-extended"));
                }
                map_filters.addOverflowToFilters(true);
            });
        });
    },
    addToAll: function addToAll(input, removing, finalize) {

        var id = $(input).attr("id");
        if (removing) {
            //remove
            $(map_filters.all_list).find("li[name='" + id + "']").each(function () {
                $(this).remove();
            });
        } else {
            //add
            $(map_filters.all_list).append("<li name='" + id + "'>" + $(input).siblings("label").first().text() + "</li>");
            $(map_filters.all_list).find("li[name='" + id + "']").each(function () {
                $(this).click(function () {
                    var nm = $(this).attr("name");
                    $("#" + nm).each(function () {
                        $(this).prop("checked", false);
                        map_filters.addToAll(this, true, true);
                    });
                });
            });
        }

        if (finalize) {
            map_filters.addOverflowToFilters();
            gmap_common.combine_markers();
        }
    },
    //clear all selected
    clear_all: function clear_all() {

        $("[spjs='clear_all']").each(function () {
            $(this).click(function () {

                $(map_filters.all_list).find("li").each(function () {

                    var nm = $(this).attr("name");
                    $(this).remove();
                    $("#" + nm).each(function () {
                        $(this).prop("checked", false);
                    });
                });

                //deselect category clear all
                $(".filters .filter-groups .clear-all:not(.hide-important)").each(function () {
                    $(this).addClass("hide-important").prevAll(".select-all").each(function () {
                        $(this).removeClass("hide-important");
                    });
                });

                map_filters.addOverflowToFilters();
                gmap_common.combine_markers();
            });
        });
    },
    //select all from category
    select_ctg: function select_ctg() {

        $("[spjs='select_childs']").each(function () {
            $(this).click(function () {

                $(this).parent().find(".checkbox").each(function () {
                    $(this).find("input[type='checkbox']").each(function () {
                        if (!$(this).prop("checked")) {
                            $(this).prop("checked", true);
                            map_filters.addToAll(this);
                        }
                    });
                });

                $(this).addClass("hide-important").nextAll(".clear-all").each(function () {
                    $(this).removeClass("hide-important");
                });
                map_filters.addOverflowToFilters();
                gmap_common.combine_markers();
            });
        });
    },
    clear_ctg: function clear_ctg() {

        $("[spjs='clear_childs']").each(function () {
            $(this).click(function () {

                $(this).parent().find(".checkbox").each(function () {
                    $(this).find("input[type='checkbox']").each(function () {
                        if ($(this).prop("checked")) {
                            $(this).prop("checked", false);
                            map_filters.addToAll(this, true);
                        }
                    });
                });

                $(this).addClass("hide-important").prevAll(".select-all").each(function () {
                    $(this).removeClass("hide-important");
                });
                map_filters.addOverflowToFilters();
                gmap_common.combine_markers();
            });
        });
    },
    //single add
    add_single: function add_single() {

        $(map_filters.filter_wrapper).find(".checkbox input[type='checkbox']").each(function () {
            $(this).click(function () {
                var is_checked = $(this).prop("checked");
                map_filters.addToAll(this, !is_checked, true);

                var all_checked = is_checked;
                if (all_checked) $(this).parentsUntil(".group-single").last().find(".checkbox input[type='checkbox']").each(function () {
                    all_checked = all_checked && $(this).prop("checked");
                });

                //active clear all
                if (all_checked) $(this).parentsUntil(".group-single").last().find(".select-all:not(.hide-important)").each(function () {
                    $(this).addClass("hide-important").nextAll(".clear-all").each(function () {
                        $(this).removeClass("hide-important");
                    });
                });
                //deselect clear all
                else $(this).parentsUntil(".group-single").last().find(".clear-all:not(.hide-important)").each(function () {
                        $(this).addClass("hide-important").prevAll(".select-all").each(function () {
                            $(this).removeClass("hide-important");
                        });
                    });
            });
        });
    },
    init: function init() {

        map_filters.addOverflowToFilters(); //overflow on start
        map_filters.filters_toggle(); //hide/show filters
        map_filters.group_toggle(); //hide/show group
        map_filters.subgroup_toggle(); //hide/show subgroup

        map_filters.clear_all();
        map_filters.select_ctg();
        map_filters.clear_ctg();
        map_filters.add_single();
    }
};

var gmap_common = {
    api_call: function api_call() {

        return $.ajax({
            type: "GET",
            url: "/api/v1/tasting/get-categories-with/children.sights.children,locations,sights.children",
            cache: false,
            scriptCharset: "utf-8"
        });
    },
    locations: {},
    combine_markers: function combine_markers() {

        var locations_all = [];
        $(map_filters.all_list).find("li").each(function (ind, item) {
            locations_all.push(gmap_common.locations[$(item).attr("name")]);
        });

        specto_gmaps.updateLocations(locations_all);
    },
    init: function init() {

        gmap_common.api_call().then(function (back) {
            //get data and make filters + map pointers

            var filtr_htm = $("<div></div>");
            var select_all = $("#LangHelpSelect_all").val();
            var clear_all = $("#LangHelpClear_all").val();

            $.each(back.data, function (ind, group) {

                var group_name_slug = group.icon.replace(/ /g, "-");
                var ins_html = $("<div class='group-single : " + group_name_slug + "'>" + "<span class='group-title'>" + group.name + "</span>" + "<div class='group-extended'>" + "<span class='select-all' spjs='select_childs'>" + select_all + "</span>" + "<em class='clear-all hide-important' spjs='clear_childs'>" + clear_all + "</em>" + "</div>" + "</div>");

                //subcategories
                $.each(group.children, function (indx, subgroup) {
                    var sub_ins = $("<div class='sub-category'>" + "<span class='sub-category-title'>" + subgroup.name + "</span>" + "<div class='category-extended'></div>" + "</div>");

                    //subcategorie sights
                    $.each(subgroup.sights, function (index, item) {
                        $(sub_ins).find(".category-extended").append("<div class='checkbox'>" + "<input type='checkbox' name='subctg_" + item.id + "' id='subctg_" + item.id + "' />" + "<label for='subctg_" + item.id + "'>" + item.title + "</label>" + "</div>");
                        gmap_common.locations["subctg_" + item.id] = $.extend(item, { p_icon: group_name_slug });
                    });

                    $(ins_html).find(".group-extended").append(sub_ins);
                });

                //single subcategorie
                $.each(group.sights, function (indx, subgroup) {

                    $(ins_html).find(".group-extended").append("<div class='sub-category single'>" + "<div class='category-extended'>" + "<div class='checkbox'>" + "<input type='checkbox' name='subctg_" + subgroup.id + "' id='subctg_" + subgroup.id + "' />" + "<label for='subctg_" + subgroup.id + "'>" + subgroup.title + "</label>" + "</div>" + "</div>" + "</div>");
                    gmap_common.locations["subctg_" + subgroup.id] = $.extend(subgroup, { p_icon: group_name_slug });;
                });

                //direct locations
                $.each(group.locations, function (indx, subgroup) {

                    $(ins_html).find(".group-extended").append("<div class='sub-category single'>" + "<div class='category-extended'>" + "<div class='checkbox'>" + "<input type='checkbox' name='loc_" + subgroup.id + "' id='loc_" + subgroup.id + "' />" + "<label for='loc_" + subgroup.id + "'>" + subgroup.title + "</label>" + "</div>" + "</div>" + "</div>");
                    gmap_common.locations["loc_" + subgroup.id] = $.extend(subgroup, { p_icon: group_name_slug });;
                });

                $(filtr_htm).append(ins_html);
            });
            $(map_filters.filter_wrapper).each(function () {
                $(this).append(filtr_htm);
            });

            //console.log(gmap_common.locations);
            map_filters.init();
        });
    }
};

$(document).ready(function () {
    if ($('#map-canvas').length > 0) {
        //init specto_gmaps
        specto_gmaps.init({
            object_selector: "map-canvas",
            on_init: function on_init() {
                //on load maps, initialize filters
                gmap_common.init();
            },
            mapOptions: {
                center: { lat: 46.555027, lng: 15.615694 },
                zoom: 14,
                minZoom: 3,
                panControl: true,
                streetViewControl: false,
                zoomControl: true,
                scaleControl: true,
                styles: [{
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#ff0000"
                    }]
                }, {
                    "featureType": "administrative",
                    "elementType": "labels.text",
                    "stylers": [{
                        "color": "#ff0000"
                    }]
                }, {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#ff0000"
                    }]
                }, {
                    "featureType": "administrative",
                    "elementType": "labels.text.stroke",
                    "stylers": [{
                        "color": "#ffffff"
                    }, {
                        "saturation": "-0"
                    }, {
                        "lightness": "0"
                    }, {
                        "gamma": "1"
                    }, {
                        "weight": "0"
                    }]
                }, {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [{
                        "color": "#f2f2f2"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [{
                        "saturation": -100
                    }, {
                        "lightness": 45
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "simplified"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [{
                        "color": "#f6f9fc"
                    }, {
                        "visibility": "on"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "saturation": "0"
                    }, {
                        "lightness": "0"
                    }, {
                        "color": "#7eafea"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "geometry.stroke",
                    "stylers": [{
                        "color": "#4a90e2"
                    }]
                }]
            },
            custom_popup_html: function custom_popup_html(location_object) {
                return "<div class='location-content : " + location_object.p_icon + "'>" + "<span class='close-btn'></span>" + "<div class='img'>" + "<img src='" + location_object.image + "' />" + "<span class='white-pin'></span>" + "</div>" + "<div class='desc'>" + "<h3>" + location_object.title + "</h3>" + location_object.description + //is in html already
                "</div>" + "<div class='commands'>" + "<a target='_blank' href='" + $("#LangHelpMore_info_url").val() + "' class='btn : btn--red : get-app-info'><span>" + $("#LangHelpMore_info").val() + "</span></a>" + "</div>" + "</div>";
            },

            has_dynamic_params: true, //if there can be different icons for markers on the same map.
            dynamic_icon_params: function dynamic_icon_params(single_location) {
                return {
                    title: single_location.title,
                    optimized: false,
                    icon: '../site/assets/img/map-icons/' + single_location.p_icon + '.png'
                };
            }
        });
    }
});